exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-83721556] .tns-visually-hidden {\n  display: none;\n}\n[data-v-83721556] .tns-nav {\n  display: flex;\n}\n[data-v-83721556] .tns-nav button {\n  width: 100%;\n  background: #cccccc;\n  border: none;\n  box-shadow: none;\n  height: 1px;\n  padding: 0px;\n  transition: background 0.15s ease-in-out;\n}\n[data-v-83721556] .tns-nav button.tns-nav-active {\n  background: #000;\n  height: 2px;\n  border-radius: 5px;\n  margin-top: -1px;\n}", ""]);

// exports
